import { combineReducers } from 'redux'
import { combineSlices } from '@reduxjs/toolkit'

//#region Device Elements
import * as logCalls from './DeviceCalls/DeviceSlices/logSlice' //logsReducer, { added, deleted } as logActions from './logSlice'
import * as deviceStateCalls from './DeviceCalls/DeviceSlices/deviceStateSlice' //logsReducer, { added, deleted } as logActions from './logSlice'
import * as autopigCalls from './DeviceCalls/DeviceSlices/autopigSlice' //logsReducer, { added, deleted } as logActions from './logSlice'
//#endregion

//#region Domain Elements
import * as strucktureCalls from './DomainCalls/DomainSlices/strucktureSlice' 
import * as feedComponentsCalls from "./FeedDataCalls/FeedDataSlices/feedComponentsSlice";
import * as feedCurvesCalls from "./FeedDataCalls/FeedDataSlices/oldFeedCurveSlice";
import * as animalCall from "./AnimalDataCalls/AnimalDataSlices/AnimalSlice";
import * as animalGroupCall from "./AnimalDataCalls/AnimalDataSlices/AnimalGroupSlice";
import * as lfSectionCall from "./LocationFeedingCalls/LocationFeedingSlices/lfStructureSlice";
import * as terminalsCall from "./LocationFeedingCalls/LocationFeedingSlices/oldTerminalsSlice";
import * as terminalTypesCall from "./LocationFeedingCalls/LocationFeedingSlices/terminalTypesSlice";
import * as lanControllerCall from "./LocationFeedingCalls/LocationFeedingSlices/lanControllerSlice";
import * as deviceInfoCall from "./LocationFeedingCalls/LocationFeedingSlices/deviceInfoSlice";
import * as milestonesCall from "./MilestoneDataCalls/MilestoneDataSlices/milestoneSlice";
import * as systemsCall from "./SystemCalls/oldSystemSlice";
import * as attentionLogCall from "./AttentionLogCalls/attentionLogSlice";
import * as widgetCall from "./WidgetCalls/WidgetSlices/widgetSlice";
import * as autoReportCall from "./WidgetCalls/WidgetSlices/autoReportSlice";
import * as reportCall from "./ReportDataCalls/reportSlice";
import * as reportTemplateCall from "./ReportDataCalls/reportTemplateSlice";
//#endregion

//#region User Elements
import * as userCalls from './UserCalls/UserSlices/userSlice'
import { animalReducer } from './AnimalDataCalls/AnimalDataSlices/animalsSlice'
import { feedCurveReducer } from './FeedDataCalls/FeedDataSlices/feedCurvesSlice'
import { systemLimitationsSlice } from './SystemCalls/systemLimitationsSlice'
import { feedComponentReducer } from './FeedDataCalls/FeedDataSlices/componentsSlice'
import { eventReducer } from './EventsDataCalls/eventsSlice'
import { sectionReducer } from './SectionsCalls/sectionsSlice'
import { locationReducer } from './SectionsCalls/locationSlice'
import { stationReducer } from './StationCalls/StationSlice'
import { terminalReducer } from './LocationFeedingCalls/LocationFeedingSlices/terminalSlice'
import { systemInfoReducer } from './SystemCalls/systemSlice'
import { consumptionReducer } from './ConsumptionCalls/consumptionSlice'
import { stationConfigReducer } from './StationCalls/stationConfigSlice'
import { stationStatusReducer } from './StationCalls/StationStatusSlice'
import { stationVisitsReducer } from './StationCalls/StationVisitsSlice'
import { stationVisitCountReducer } from './StationCalls/StationVisitCountSlice'
import { stationConsumptionReducer } from './StationCalls/StationConsumptionSlice'
//#endregion

export const deviceCalls_Reducer = combineReducers({
  logs: logCalls.default,
  state: deviceStateCalls.default,
  autopig: autopigCalls.default
})
export const DeviceActions = {
  log: logCalls.LogActions,
  state: deviceStateCalls.DeviceStateActions,
  autopig: autopigCalls.AutopigActions
}

export const domainCalls_Reducer = combineReducers({
  struckture: strucktureCalls.default,
  feedComponents: feedComponentsCalls.default,
  feedCurves: feedCurvesCalls.default,
  animal: animalCall.default,
  animalGroups: animalGroupCall.default,
  lfSections: lfSectionCall.default,
  terminals: terminalsCall.default,
  terminalTypes: terminalTypesCall.default,
  lanControllers: lanControllerCall.default,
  deviceInfo: deviceInfoCall.default,
  milestones: milestonesCall.default,
  systems: systemsCall.default,
  attentionLog: attentionLogCall.default,
  report: reportCall.default,
  reportTemplate: reportTemplateCall.default,
  widgetCall: widgetCall.default,
  autoReport: autoReportCall.default
})
export const DomainActions = {
  struckture: strucktureCalls.StrucktureActions,
  feedComponents: feedComponentsCalls.FeedComponentsActions,
  feedCurves: feedCurvesCalls.FeedCurvesActions,
  animals: animalCall.AnimalActions,
  animalGroups: animalGroupCall.animalGroupActions,
  lfSections: lfSectionCall.LfSectionActions,
  terminals: terminalsCall.TerminalsActions,
  terminalTypes: terminalTypesCall.TerminalTypesActions,
  lanControllers: lanControllerCall.LanControllerActions,
  deviceInfo: deviceInfoCall.DeviceInfoActions,
  milestones: milestonesCall.MilestoneActions,
  systems: systemsCall.SystemActions,
  attentionLog: attentionLogCall.attentionLogActions,
  report: reportCall.ReportActions,
  reportTemplate: reportTemplateCall.ReportTemplateActions,
  widgets: widgetCall.widgetActions,
  autoReport: autoReportCall.autoReportActions
}

// export const userCalls_Reducer = combineReducers({
//   ???: userCalls.default,
// })
// export const UserActions = {
//   ???: userCalls.UserActions,
// }

// milestones
// consumption

const gqlReducer = combineSlices({
  device: deviceCalls_Reducer,
  domain: domainCalls_Reducer,
  user: userCalls.default,
  animals: animalReducer,
  feedCurves: feedCurveReducer,
  feedComponents: feedComponentReducer,
  events: eventReducer,
  locations: locationReducer, 
  systemLimitations: systemLimitationsSlice.reducer,
  sections: sectionReducer,
  stations: stationReducer,
  stationStatus: stationStatusReducer,
  stationConfigs: stationConfigReducer,
  stationVisits: stationVisitsReducer,
  stationVisitCount: stationVisitCountReducer,
  stationConsumption: stationConsumptionReducer,
  terminals: terminalReducer, 
  systems: systemInfoReducer,
  consumption: consumptionReducer,
})
export const gqlActions = {
  device: DeviceActions,
  domain: DomainActions,
  user: userCalls.UserActions
}

export default gqlReducer


